// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-feedback-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-feedback-content {
  background-color: #1f2937;
  color: #f1f5f9;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 440px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.modal-feedback-title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: #f1f5f9 !important;
  text-align: center;
}

.modal-feedback-input-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.modal-feedback-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.modal-feedback-btn {
  background-color: #4f5865;
  color: #f8fafc;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.25s ease;
}

.modal-feedback-btn:hover {
  background-color: #18191d;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ModalFeedback/ModalFeedback.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal-feedback-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(6px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-feedback-content {\n  background-color: #1f2937;\n  color: #f1f5f9;\n  padding: 24px;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 440px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.modal-feedback-title {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #f1f5f9 !important;\n  text-align: center;\n}\n\n.modal-feedback-input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.modal-feedback-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.modal-feedback-btn {\n  background-color: #4f5865;\n  color: #f8fafc;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background-color 0.25s ease;\n}\n\n.modal-feedback-btn:hover {\n  background-color: #18191d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
